<template>
    <HeaderCardsLayout variant="No-Logo">
        <template #headline>{{ $t('event-series-create') }}</template>
        <template #breadcrumb>
            <Breadcrumb :headline="$t('breadcrumb')" :current-page="$t('event-series-create')">
                <BreadcrumbLink :target="{ name: 'events' }">
                    <BallotIcon class="mr-1 shrink-0" />
                    {{ $t('event-wiki') }}
                </BreadcrumbLink>
            </Breadcrumb>
        </template>
        <template #body>
            <PaddedContentTop>
                <div class="bg-gray-50">
                    <div class="px-4 pb-4 pt-4">
                        <EventSeriesCreateForm />
                    </div>
                </div>
            </PaddedContentTop>
        </template>
    </HeaderCardsLayout>
</template>

<script setup lang="ts">
import Breadcrumb from '@/components/Breadcrumb/Breadcrumb.vue';
import BreadcrumbLink from '@/components/Breadcrumb/BreadcrumbLink.vue';
import BallotIcon from '@/components/Icon/BallotIcon.vue';
import HeaderCardsLayout from '@/components/Layout/HeaderCardsLayout.vue';
import PaddedContentTop from '@/components/Layout/PaddedContentTop.vue';
import { $t } from '@/plugins/fluent';
import { useHeadSafe } from '@unhead/vue';
import EventSeriesCreateForm from '../forms/EventSeriesCreateForm.vue';

useHeadSafe({ title: () => `${$t('event-series-create')} - ${$t('event-wiki')}` });
</script>
